import { Dialog, Grid, IconButton } from '@mui/material';
import React from 'react';
import { formatPriceBreakupValues } from '../../../Utils/helperFns';
import Images from '../../../Utils/images';

function AdditionalShifts({
  open,
  onClose,
  additionalShiftsData,
}: {
  open: boolean;
  onClose: () => void;
  additionalShiftsData: any;
}) {
  return (
    <Dialog open={open} onClose={onClose}>
      <div className="dialogWrapper warning orderAddress w__368">
        <div className="dialogHeader flex sps_between">
          View Additional Charges
          <IconButton onClick={onClose}>
            <img src={Images.CLOSE} />
          </IconButton>
        </div>

        <div className="doalogBody small body-scroll-sm body-right-space">
          <div className="formContainer">
            <Grid container spacing={2}>
              <Grid item md={12} xs={12}>
                <div className="price_breakup_list">
                  {/* Only for BUY Mode */}

                  <h3>
                    Mileage (
                    {formatPriceBreakupValues(
                      additionalShiftsData?.mileageDistance,
                    )}{' '}
                    miles X ${additionalShiftsData.mileageRate ?? 0}){' '}
                    <strong>
                      $
                      {formatPriceBreakupValues(
                        additionalShiftsData?.mileageCost ?? 0,
                      )}
                    </strong>
                  </h3>


                    <h3>
                      Rush Fee{' '}
                      <strong>
                        $
                        {formatPriceBreakupValues(
                          additionalShiftsData?.rushFee ?? 0,
                        )}
                      </strong>
                    </h3>
                  
                  {additionalShiftsData?.applyPerDiem ? (
                    <h3>
                      Per Diem{' '}
                      <strong>
                        $
                        {formatPriceBreakupValues(
                          additionalShiftsData?.perDiemCost ?? 0,
                        )}
                      </strong>
                    </h3>
                  ) : null}

                  <div className="divider"></div>
                  <h3>
                    Total Additional Charges{' '}
                    <strong>
                      $
                      {formatPriceBreakupValues(
                        (additionalShiftsData?.mileageCost || 0) +
                          (additionalShiftsData?.applyPerDiem
                            ? additionalShiftsData?.perDiemCost ?? 0
                            : 0) +
                          (additionalShiftsData?.rushFee ?? 0),
                      )}
                    </strong>
                  </h3>
                  <div className="divider"></div>
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </Dialog>
  );
}

export default AdditionalShifts;
